import React from "react";

import { Form, Select, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";

function Interests({ interests, setInterests, properties }) {
  const addInterest = () => {
    const newInterest = {
      id: uuidv4(),
      interest: "",
    };
    setInterests([...interests, newInterest]);
  };

  const removeInterest = (id) => {
    const updatedInterests = interests.filter((item) => {
      return item.id === id;
    });
    setInterests(updatedInterests);
  };

  const handleChange = (value, name, id) => {
    const updatedInterests = interests.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setInterests(updatedInterests);
  };

  console.log("properties", properties);
  console.log("interestsinterestsinterestsinterests", interests);

  return (
    <ul>
      {interests?.map((item) => (
        <li key={item.id}>
          <Form.Item label="Property, Unit or Campaign">
            <Row>
              <Col span={11}>
                <Form.Item>
                  <Select
                    options={properties}
                    onChange={(value) =>
                      handleChange(value, "interest", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={1}>
                {interests.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeInterest(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}
      <Form.Item label=" " wrapperCol={{ span: 8 }}>
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addInterest}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Interest
        </Button>
      </Form.Item>
    </ul>
  );
}

export default Interests;
